import { useCallback } from 'react';

import { useTagCreate, useTagByNameLazy } from './use-tags';

export const useEnsureTag = () => {
  const { query: getTagByName, isLoading } = useTagByNameLazy();
  const { mutate: createTag } = useTagCreate();

  const ensureTag = useCallback(
    async (name: string, color?: string): Promise<string> => {
      const existingTag = getTagByName(name);
      if (existingTag) return existingTag.id;

      const newTag = await createTag({ name, color });
      return newTag.id;
    },
    [getTagByName, createTag]
  );

  return { ensureTag, isReady: !isLoading };
};
